import { FC, ReactNode } from 'react';

export type StatusBadgeTone = 'success' | 'neutral' | 'warning' | 'danger' | 'info';

export type StatusBadgeProps = {
  /** The tone. Defaults to neutral. */
  tone?: StatusBadgeTone;
  /** Show the leading status dot. Defaults to true. */
  dot?: boolean;
  children: ReactNode;
  /** Placement only: the pill's shape and colours are the badge's. */
  className?: string;
};

/**
 * A status pill: one shape, five tones and an optional leading dot.
 *
 * It carries no bundle or page meaning - the caller names the status and picks
 * the tone. It replaces the per-page status, dot and badge rules as those pages
 * migrate.
 */
const StatusBadge: FC<StatusBadgeProps> = ({ tone = 'neutral', dot = true, children, className }) => (
  <span className={['ui-status-badge', 'ui-status-badge--' + tone, className].filter(Boolean).join(' ')}>
    {dot && <span className="ui-status-badge-dot" aria-hidden="true" />}
    {children}
  </span>
);

export default StatusBadge;
